export const MS_IN_A_MINUTE = 60000;
export const MS_IN_AN_HOUR = 3600000;
export const MS_IN_A_DAY = 86400000;
export const TRACK_AWARD_EXPIRY_DAYS = 760; // Used to be in track.awardExpiryDays, now missing from response?